/**
 * @file Waldogram modal sucess container.
 */

import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../components/global/modal/withModal';
import Button from '../../../../components/global/Button';
import { getAsset } from '../../../../util/assets';

const propTypes = {
  onReset: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onGoBack: PropTypes.func,
  goBackLabel: PropTypes.string,
  historyPath: PropTypes.string,
};

const WaldogramSuccessModal = ({
  onReset,
  onClose,
  onGoBack,
  goBackLabel = 'Back to the gallery',
  historyPath,
}) => {
  return (
    <div className="text-center p-lg-5">
      <img
        src={getAsset('/waldo-icon.svg')}
        alt=""
        className="mb-3"
        width="66"
      />

      <h4>Thank you for your order!</h4>

      <p className="mb-3 text-dark">Your card is on its way!</p>

      <p>What&rsquo;s next?</p>

      <Button
        onClick={() => {
          onClose();
          onReset();
        }}
        btnBlock
      >
        Send another card
      </Button>

      <Button
        btnStyle="secondary"
        to={historyPath}
        onClick={onGoBack}
        btnBlock
        className="mb-1"
      >
        {goBackLabel}
      </Button>
    </div>
  );
};

WaldogramSuccessModal.propTypes = propTypes;

export default withModal(WaldogramSuccessModal, {
  hideHeader: true,
  size: 'sm',
});
